import { Step, StepContent, StepLabel, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";
import { DoneIcon } from "./StepIcons";
import TransactionHistoryBase from "./TransactionHistoryBase";
import styles from "./styles";
import Note from "./Note";

const WithoutOrderIdSwitchOut = ({
  amountOnly,
  actAmount,
  salesChargeAmount,
  unit,
  completedDate,
  details,
  compUnitPrice,
}) => (
  <TransactionHistoryBase>
    {/* Completed */}
    <Step active>
      <StepLabel icon={<DoneIcon active />}>
        <Typography
          color="textPrimary"
          style={{
            ...styles.baseFont,
            ...styles.label,
            color: "#000000",
          }}
        >
          Completed
        </Typography>
      </StepLabel>
      <StepContent style={{ marginTop: "0" }}>
        <div
          style={{
            marginTop: "3px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            Requested Switch Out
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            RM{" "}
            <NumberFormat
              value={amountOnly}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale
            />
          </Typography>
        </div>
        <div
          style={{
            marginTop: "3px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            Adjusted Switch Out
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            RM{" "}
            <NumberFormat
              value={actAmount - salesChargeAmount}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale
            />
          </Typography>
        </div>
        <div
          style={{
            marginTop: "8px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography style={{ ...styles.baseFont, ...styles.content }}>
            Unit: {unit}
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
              textAlign: "right",
            }}
          >
            Unit Price: RM
            <NumberFormat
              value={compUnitPrice}
              thousandSeparator
              displayType="text"
              decimalScale={4}
              fixedDecimalScale
            />
          </Typography>
        </div>

        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
            ...styles.date,
            marginTop: "8px",
          }}
        >
          {moment(completedDate)
            .utcOffset("+0800")
            .format("DD MMM YYYY")}
        </Typography>
      </StepContent>
      <Note>
        Note: This transaction is the adjusted Switch Out request. It may be
        adjusted in different fund.
      </Note>
    </Step>
  </TransactionHistoryBase>
);

export default WithoutOrderIdSwitchOut;
